import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import ProductService from 'src/services/product.service'
import { IProductQrLinkRespDto, IUpdateProductQrLinkDto } from 'src/types'

export const useUpdateProductQrLink = () => {
  const queryClient = useQueryClient()

  return useMutation((dto: IUpdateProductQrLinkDto) => ProductService.updateQrLink(dto), {
    onSuccess: (data, vars) => {
      if (!data) return

      const queryData: IProductQrLinkRespDto = { override_url: vars.overrideUrl }
      queryClient.setQueryData([QUERY_KEYS.PRODUCT_URL, vars.id, vars.code], queryData)
    },
  })
}
